/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { rentalContractEditForm } from "../../variables";

/* Import Function */
import { setExteriorDataByRentalContractModal } from "../../rentContract/carScratches/exterior";
import { setInteriorDataByRentalContractModal } from "../../rentContract/carScratches/interior";

/* Define Function */
/**
 * Get Boolean Values
 */
const convertNumberToBoolean = (value: number) => {
  return value == 1;
};

const getAxiosOptions = (scheduleId: Number) => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/rental_contract",
    method: "GET",
    params: {
      schedule_id: scheduleId,
    },
  };

  return axiosOptions;
};

export const getRentalContract = async (scheduleId: Number) => {
  // Get Axios Option
  const axiosOptions = await getAxiosOptions(scheduleId);
  await axios(axiosOptions)
    .then(async (result) => {
      // Set RentalContract
      setRentalContract(result.data.data);
      await setCarChecksheet(result.data.data.carChecksheet);
      setExteriorDataByRentalContractModal(
        result.data.data.carChecksheet.exteriorCheck
      );
      setInteriorDataByRentalContractModal(
        result.data.data.carChecksheet.interiorCheck
      );
    })
    .catch((error) => {
      console.log(error);
      toastr.error("車種情報取得に失敗しました");
    });
};

const setRentalContract = (rentContract: any) => {
  rentalContractEditForm.id = rentContract.id;
  rentalContractEditForm.scheduleId = rentContract.scheduleId;
  rentalContractEditForm.typeId = rentContract.typeId;
  rentalContractEditForm.slipNo = rentContract.slipNo;
  rentalContractEditForm.managerId = rentContract.managerId;
  rentalContractEditForm.dispatchDate = rentContract.dispatchDate;
  rentalContractEditForm.rentCarNo = rentContract.rentCarNo;
  rentalContractEditForm.rentCarId = rentContract.rentCarId;
  rentalContractEditForm.dischargeAmount = rentContract.dischargeAmount;
  rentalContractEditForm.nocSubscriptionAmount = rentContract.nocSubscriptionAmount;
  rentalContractEditForm.contractorCompanyName = rentContract.contractorCompanyName;
  rentalContractEditForm.contractorAddress = rentContract.contractorAddress;
  rentalContractEditForm.contractorManager = rentContract.contractorManager;
  rentalContractEditForm.contractorTel = rentContract.contractorTel;
  rentalContractEditForm.driverName = rentContract.driverName;
  rentalContractEditForm.driverSex = rentContract.driverSex;
  rentalContractEditForm.driverBirthday = rentContract.driverBirthday;
  rentalContractEditForm.driverAddress = rentContract.driverAddress;
  rentalContractEditForm.driverTel = rentContract.driverTel;
  rentalContractEditForm.driverLicenseNo = rentContract.driverLicenseNo;
  rentalContractEditForm.drivingLicenseTypeId = rentContract.drivingLicenseTypeId;
  rentalContractEditForm.driverLicenseExpireYear = rentContract.driverLicenseExpireYear;
  rentalContractEditForm.lentDate = rentContract.lentDate;
  rentalContractEditForm.lentTime = rentContract.lentTime;
  rentalContractEditForm.lentDateDrivingDistance = rentContract.lentDateDrivingDistance;
  rentalContractEditForm.returnDate = rentContract.returnDate;
  rentalContractEditForm.returnTime = rentContract.returnTime;
  rentalContractEditForm.returnDateDrivingDistance = rentContract.returnDateDrivingDistance;
  rentalContractEditForm.vehicleInspectionExpiryDate = rentContract.vehicleInspectionExpiryDate;
  rentalContractEditForm.maintenanceDate = rentContract.maintenanceDate;
  rentalContractEditForm.maintenancePersonId = rentContract.maintenancePersonId;
  rentalContractEditForm.usageObjectiveId = rentContract.usageObjectiveId;
  rentalContractEditForm.destAddress = rentContract.destAddress;
  rentalContractEditForm.destManager = rentContract.destManager;
  rentalContractEditForm.destTel = rentContract.destTel;
  rentalContractEditForm.fuel = rentContract.fuel;
  rentalContractEditForm.registrationAt = rentContract.registrationAt;
  // Other
  rentalContractEditForm.isDisableButtons.registration = rentContract.isDisableButtons.registration;
  rentalContractEditForm.isDisableButtons.complete = rentContract.isDisableButtons.complete;
  rentalContractEditForm.isDisableButtons.export = rentContract.isDisableButtons.export;
};

const setCarChecksheet = (carChecksheet: any) => {
  rentalContractEditForm.carChecksheetId = carChecksheet.carChecksheetId;
  rentalContractEditForm.rentContractId = carChecksheet.rentContractId;
  rentalContractEditForm.checkManagerId = carChecksheet.checkManagerId;
  rentalContractEditForm.processedDate = carChecksheet.processedDate;
  rentalContractEditForm.brakeRoom = convertNumberToBoolean(carChecksheet.brakeRoom);
  rentalContractEditForm.brakeEffective = convertNumberToBoolean(carChecksheet.brakeEffective);
  rentalContractEditForm.brakeFluid = convertNumberToBoolean(carChecksheet.brakeFluid);
  rentalContractEditForm.tireAir = convertNumberToBoolean(carChecksheet.tireAir);
  rentalContractEditForm.tireGrooveDepth = convertNumberToBoolean(carChecksheet.tireGrooveDepth);
  rentalContractEditForm.tireNoDamage = convertNumberToBoolean(carChecksheet.tireNoDamage);
  rentalContractEditForm.batteryFull = convertNumberToBoolean(carChecksheet.batteryFull);
  rentalContractEditForm.batteryElec = convertNumberToBoolean(carChecksheet.batteryElec);
  rentalContractEditForm.lampsNoDefect = convertNumberToBoolean(carChecksheet.lampsNoDefect);
  rentalContractEditForm.lampsNoDamage = convertNumberToBoolean(carChecksheet.lampsNoDamage);
  rentalContractEditForm.engineOil = convertNumberToBoolean(carChecksheet.engineOil);
  rentalContractEditForm.engineFunbelt = convertNumberToBoolean(carChecksheet.engineFunbelt);
  rentalContractEditForm.engineNoDefect = convertNumberToBoolean(carChecksheet.engineNoDefect);
  rentalContractEditForm.speedControl = convertNumberToBoolean(carChecksheet.speedControl);
  rentalContractEditForm.windowLiquid = convertNumberToBoolean(carChecksheet.windowLiquid);
  rentalContractEditForm.windowWiper = convertNumberToBoolean(carChecksheet.windowWiper);
  rentalContractEditForm.equipEtc = convertNumberToBoolean(carChecksheet.equipEtc);
  rentalContractEditForm.driveRecorder = convertNumberToBoolean(carChecksheet.driveRecorder);
  rentalContractEditForm.equipNavi = convertNumberToBoolean(carChecksheet.equipNavi);
  rentalContractEditForm.smokeBomb = convertNumberToBoolean(carChecksheet.smokeBomb);
  rentalContractEditForm.tools = convertNumberToBoolean(carChecksheet.tools);
  rentalContractEditForm.spareTire = convertNumberToBoolean(carChecksheet.spareTire);
  rentalContractEditForm.triangular = convertNumberToBoolean(carChecksheet.triangular);
  rentalContractEditForm.repairKit = convertNumberToBoolean(carChecksheet.repairKit);
  rentalContractEditForm.winch = convertNumberToBoolean(carChecksheet.winch);
  rentalContractEditForm.carWashExterior = convertNumberToBoolean(carChecksheet.carWashExterior);
  rentalContractEditForm.carWashInterior = convertNumberToBoolean(carChecksheet.carWashInterior);
  rentalContractEditForm.scratchCheck = convertNumberToBoolean(carChecksheet.scratchCheck);
  rentalContractEditForm.presence = convertNumberToBoolean(carChecksheet.presence);
  rentalContractEditForm.exteriorCheck = carChecksheet.exteriorCheck;
  rentalContractEditForm.interiorCheck = carChecksheet.interiorCheck;
  rentalContractEditForm.memo = carChecksheet.memo;
  rentalContractEditForm.signaturePath = carChecksheet.signaturePath;
  rentalContractEditForm.isAgreement = convertNumberToBoolean(carChecksheet.isAgreement);
};
